import React, { useContext } from "react";
import { Grid } from "@mui/material";
import NoTicketDetail from "../../../FlightPackage/NoTicketDetail";
import { TicketLineItemExtended } from "../../../Utils/TypeExtensions";
import { MINIMUM_LINE_ITEM_TYPES, RATES_AND_MINS_LINE_ITEM_TYPES } from "../../../sharedCode/metadata";
import { useLiveQuery } from "dexie-react-hooks";
import { saveTicketChanges, TicketDatabase } from "../../../Utils/TicketDatabase";
import DetailPage from "../../../Components/navigation/detailPage";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import { TicketLineItemType } from "../../../sharedCode/avroGraphql";
import MinimumsAveraging from "../../../Components/ticket/minimumsAveraging";
import MinimumsRow from "../../../Components/ticket/minimumsRow";
import { GlobalContext } from "../../../Utils/Contexts";

// TODO ROUTING - this now assumes that line items will exist to hold the mins - check at ticket create time and add them then
export function TicketMinimums(props: TicketProps): JSX.Element | null {
    const context = useContext(GlobalContext);

    const lineItemTypeList = useLiveQuery(async () => TicketDatabase.ticketLineItemType.toArray());

    if (!lineItemTypeList) return <></>;

    const applicableLineItems = lineItemTypeList.filter((r: TicketLineItemType) => RATES_AND_MINS_LINE_ITEM_TYPES.findIndex((id) => id === r.id) >= 0) ?? [];

    if (!props.ticket) return <NoTicketDetail />;

    if (applicableLineItems.length <= 0) return <></>;

    return (
        <DetailPage>
            <Grid>
                <Grid container spacing={1} flexDirection={"column"}>
                    <MinimumsAveraging {...props} />
                </Grid>
                <Grid container spacing={1} flexDirection={"column"}>
                    {MINIMUM_LINE_ITEM_TYPES.map((typeId) => (
                        <MinimumsRow key={`row${typeId}`} lineItemTypeId={typeId} mergeRowChanges={mergeRowChanges} {...props} />
                    ))}
                </Grid>
            </Grid>
        </DetailPage>
    );

    function mergeRowChanges(locationId: number, changes: Record<string, unknown>) {
        const lineItems = props.ticket?.LineItems?.map((lineItem) => {
            if (lineItem?.id === locationId) {
                return { ...lineItem, ...changes } as TicketLineItemExtended;
            } else {
                return lineItem;
            }
        });

        saveTicketChanges(props.ticket.id, { LineItems: lineItems }).catch(() => props.showForceReloadDialogue());
    }
}
